import React from "react";
import BookingForm from "../components/BookingForm";
import { SITE } from "../data/site";
import { Phone } from "lucide-react";

export default function Book() {
  return (
    <div className="pt-32 pb-24 bg-[#050505] min-h-screen" data-testid="book-page">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="label-eyebrow mb-3">Book Your Ride</div>
          <h1 className="font-display text-5xl sm:text-6xl text-white tracking-tight">
            Reserve your luxury transportation.
          </h1>
          <p className="text-white/65 mt-5 leading-relaxed">
            Tell us where, when, and what vehicle you'd like. Our dispatch team will confirm your reservation within minutes.
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <a href={`tel:${SITE.phonesTel.virginia}`} className="btn-outline" data-testid="book-call-va">
              <Phone size={14} /> Virginia · {SITE.phones.virginia}
            </a>
            <a href={`tel:${SITE.phonesTel.dispatch}`} className="btn-outline" data-testid="book-call-dispatch">
              <Phone size={14} /> Dispatch · {SITE.phones.dispatch}
            </a>
          </div>
        </div>
        <BookingForm eyebrow="Reservation Details" />
      </div>
    </div>
  );
}
